import { Dispatch, UnknownAction } from '@reduxjs/toolkit';
import { pushNotification } from 'store/notifications/notifications.slices';

export const notificationsMiddleware =
  (store) => (next: Dispatch<UnknownAction>) => (action: UnknownAction) => {
    switch (action.type) {
      case 'users/login/fulfilled':
      case 'users/googleAuth/fulfilled':
        store.dispatch(
          pushNotification({ message: 'Login successful', type: 'success' })
        );
        break;
      case 'users/login/rejected':
      case 'users/googleAuth/rejected':
        store.dispatch(
          pushNotification({ message: 'Login failed', type: 'error' })
        );
        break;
      case 'users/register/fulfilled':
        store.dispatch(
          pushNotification({
            message: 'Registration successful',
            type: 'success',
          })
        );
        break;
      case 'users/register/rejected':
        store.dispatch(
          pushNotification({ message: 'Registration failed', type: 'error' })
        );
        break;

      case 'users/verifyEmail/fulfilled':
        store.dispatch(
          pushNotification({
            message: 'Email verified. You can now login.',
            type: 'success',
          })
        );
        break;
      case 'users/verifyEmail/rejected':
        store.dispatch(
          pushNotification({
            message: 'Email verification failed',
            type: 'error',
          })
        );
        break;
      case 'users/requestResetPassword/fulfilled':
        store.dispatch(
          pushNotification({
            message: 'Reset password email sent. Please check your email.',
            type: 'success',
          })
        );
        break;
      case 'users/requestResetPassword/rejected':
        store.dispatch(
          pushNotification({
            message: 'Reset password email failed',
            type: 'error',
          })
        );
        break;

      case 'users/resetPassword/fulfilled':
        store.dispatch(
          pushNotification({
            message: 'Password reset successful. You can now login.',
            type: 'success',
          })
        );
        break;
      case 'users/resetPassword/rejected':
        store.dispatch(
          pushNotification({
            message: 'Password reset failed',
            type: 'error',
          })
        );
        break;
      default:
        break;
    }
    return next(action);
  };
